import objectPath from 'object-path'
import { getCurrentUi } from 'designer/component/action/Data'

const getRuleActiveTabTarget = (action = {}, target = '') => {
  return (
    target ||
    action.target ||
    action.targetKey ||
    action.key ||
    action.valueKey ||
    action.targetName ||
    action.targetOptionValue ||
    action.formDataKey ||
    ''
  )
}

const getRuleActiveTabKey = (jsonForm = {}, targetKey = '') => {
  let fullKey = objectPath.get(jsonForm, ['schema', 'mapKey', targetKey])
  let keyList = String(fullKey || targetKey || '')
    .split('.')
    .filter((key) => key)

  keyList.pop()
  return keyList.pop() || ''
}

const getRuleActiveTabTargetTagname = (
  jsonForm = {},
  action = {},
  targetKey = '',
) => {
  if (action.targetTagname) return action.targetTagname

  let targetUi = getCurrentUi(targetKey, jsonForm.schema, jsonForm.uischema)
  return targetUi?.tagname || ''
}

const setRuleActiveTab = (
  designContext = {},
  tabKey,
  tabPanelKey,
) => {
  let {
    jsonForm = {},
    tabParamActive = {},
    setTabParamActive,
    isUiChanged = {},
    setIsUiChanged,
    setTabActiveState,
  } = designContext
  if (!tabKey || !tabPanelKey) return undefined

  let tabUi = getCurrentUi(tabKey, jsonForm.schema, jsonForm.uischema)
  let tabPanelUi = getCurrentUi(
    tabPanelKey,
    jsonForm.schema,
    jsonForm.uischema,
  )
  if (!tabUi?.key || !tabPanelUi?.key) return undefined
  let activeName = objectPath.get(isUiChanged, ['activeTab', tabKey])
  if (tabPanelUi?.name && activeName === tabPanelUi.name) return undefined

  let filterParam = (tabUi?.param || []).filter(
    (param) => param.tabKey === tabPanelKey,
  )

  if (setTabActiveState) {
    setTabActiveState({
      tabKey,
      tabPanelName: tabPanelUi.name,
      filterParam,
      shouldSetParam: true,
      tabState: {
        isActiveTab: true,
        tabKey: tabPanelKey,
        tabPanelUi,
      },
    })
  } else {
    objectPath.set(tabParamActive, tabKey, filterParam)
    if (setTabParamActive) setTabParamActive(tabParamActive)
    objectPath.set(isUiChanged, ['activeTab', tabKey], tabPanelUi.name)
    objectPath.set(isUiChanged, tabKey, {
      isActiveTab: true,
      tabKey: tabPanelKey,
      tabPanelUi,
    })
    if (setIsUiChanged) setIsUiChanged(isUiChanged)
  }

  return {
    key: tabKey,
    tabKey: tabPanelKey,
    tabPanelUi,
  }
}

export const onRuleActiveTab = (
  designContext = {},
  action = {},
  data = {},
  target = '',
) => {
  let { jsonForm = {}, isUiChanged = {} } = designContext
  let formData = data.formData || jsonForm.formData || {}
  let targetKey = getRuleActiveTabTarget(action, target)
  if (!targetKey) return undefined
  let targetTagname = getRuleActiveTabTargetTagname(
    jsonForm,
    action,
    targetKey,
  )

  if (targetTagname === 'tabPanel') {
    let tabKey = getRuleActiveTabKey(jsonForm, targetKey)
    let defaultActiveKey = objectPath.get(isUiChanged, [tabKey, 'tabKey'])
    if (defaultActiveKey === targetKey) return undefined

    return setRuleActiveTab(designContext, tabKey, targetKey)
  }

  let tabUi = getCurrentUi(targetKey, jsonForm.schema, jsonForm.uischema)
  let activeTabKey = action.activeTabField?.key
  if (!tabUi?.key || !activeTabKey) return undefined

  let activeTabValue = objectPath.get(formData, activeTabKey)
  let foundActive = (tabUi.param || []).find(
    (param) => param.name === action.name && param.value === activeTabValue,
  )
  let tabPanelKey = foundActive?.tabKey
  let defaultActiveKey = objectPath.get(isUiChanged, [targetKey, 'tabKey'])
  if (!tabPanelKey || defaultActiveKey === tabPanelKey) return undefined

  return setRuleActiveTab(designContext, targetKey, tabPanelKey)
}

export const onRuleClearActiveTab = (
  designContext = {},
  action = {},
  target = '',
) => {
  let { jsonForm = {} } = designContext
  let targetKey = getRuleActiveTabTarget(action, target)
  let targetTagname = getRuleActiveTabTargetTagname(
    jsonForm,
    action,
    targetKey,
  )
  if (targetTagname !== 'tabPanel') return undefined

  let tabKey = getRuleActiveTabKey(jsonForm, targetKey)
  if (!tabKey) return undefined

  let tabUi = getCurrentUi(tabKey, jsonForm.schema, jsonForm.uischema)
  let defaultActiveKey = tabUi?.elements?.[0]?.key || ''
  if (!defaultActiveKey) return undefined

  return setRuleActiveTab(designContext, tabKey, defaultActiveKey)
}
